import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { WorkflowV1 } from "../shared/interfaces/WorkflowV1";
import { WorkflowV2 } from "../shared/interfaces/WorkflowV2";

export function useWorkflowById(workflowId: number, callbacks?: QueryCallbacks<WorkflowV1 | WorkflowV2>) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["workflowById", workflowId],
    queryFn: async () => {
      if (workflowId) return await apiContext.workflowApis.getWorkflowById(workflowId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
